export enum TimeRange {
  TEN_MIN = '10m',
  THIRTY_MIN = '30m',
  ONE_HOUR = '1h',
  THREE_HOURS = '3h',
  SIX_HOURS = '6h',
  TWELVE_HOURS = '12h',
  ONE_DAY = '1d',
  TWO_DAYS = '2d',
  THREE_DAYS = '3d',
  SEVEN_DAYS = '7d',
  CUSTOM = 'custom',
}

/**
 * Convert TimeRange enum to minutes
 */
export const timeRangeToMinutes = (timeRange: TimeRange): number => {
  switch (timeRange) {
    case TimeRange.TEN_MIN:
      return 10
    case TimeRange.THIRTY_MIN:
      return 30
    case TimeRange.ONE_HOUR:
      return 60
    case TimeRange.THREE_HOURS:
      return 180
    case TimeRange.SIX_HOURS:
      return 360
    case TimeRange.TWELVE_HOURS:
      return 720
    case TimeRange.ONE_DAY:
      return 1440
    case TimeRange.TWO_DAYS:
      return 2880
    case TimeRange.THREE_DAYS:
      return 4320
    case TimeRange.SEVEN_DAYS:
      return 10080
    case TimeRange.CUSTOM:
      return 0 // N/A for custom
  }
}

export interface DateFilter {
  startDate: string | null
  endDate: string | null
}

export interface AttributeValueFilter {
  attributeCode: string
  value: string
}

export interface FiltersState {
  timeRange: TimeRange
  customDateRange: DateFilter
  attributeValues: AttributeValueFilter[]
}

/**
 * Common date range filter for GraphQL queries
 */
export interface DateRangeFilter {
  from: string
  to: string
}

/**
 * Common attribute value filter for GraphQL queries
 */
export interface AttributeValueGraphQLFilter {
  attributeCode: string
  attributeValue: string
}

/**
 * Common filters used across all data fetching operations
 * Contains calculated/effective values ready to use in GraphQL queries
 */
export interface CommonQueryFilters {
  dateRange: DateRangeFilter
  attributeValues: AttributeValueGraphQLFilter[]
}
